/* eslint-disable no-undef */
// import { STORAGE_USER_INFO } from "./constant";

import { Toast } from "vant";

/**
 * 设置storage
 * @param {*} key
 * @param {*} data
 */
export function setStorage(key, data) {
  localStorage.setItem(key, JSON.stringify(data));
}

/**
 * 获取storage
 * @param {*} key
 */
export function getStorage(key) {
  const data = localStorage.getItem(key);
  try {
    return JSON.parse(data);
  } catch (err) {
    return data;
  }
}

/**
 * 删除storage
 * @param {*} key
 */
export function removeStorage(key) {
  localStorage.removeItem(key);
}

/**
 * 判断是否为admin权限
 */
export function hasAuth() {
  // const { is_master } = getStorage(STORAGE_USER_INFO);
  // return is_master &&  === 1;
  return true;
}

/**
 * 是否有该参数
 * @param {*} name 
 * @returns 
 */
export function GetUrlParam(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

/**
 * 判断是否是在pc端
 */
export function isPc() {
  var userAgentInfo = navigator.userAgent;
  var Agents = ['Android', 'iPhone',
    'SymbianOS', 'Windows Phone',
    'iPad', 'iPod'
  ];
  var flag = true;
  for (var i = 0; i < Agents.length; i++) {
    if (userAgentInfo.indexOf(Agents[i]) != -1) {
      flag = false;
      break;
    }
  }
  return flag;
}

export function changeURLArg(url, arg, arg_val) {
  var pattern = arg + '=([^&]*)';
  var replaceText = arg + '=' + arg_val;
  if (url.match(pattern)) {
    var tmp = '/(' + arg + '=)([^&]*)/gi';
    tmp = url.replace(eval(tmp), replaceText);
    return tmp;
  } else {
    if (url.match('[\?]')) {
      return url + '&' + replaceText;
    } else {
      return url + '?' + replaceText;
    }
  }
  // return url+'\n'+arg+'\n'+arg_val; 
}

/**
 * ticket 微信分享凭证， detail详情
 */
export function share(ticket, detail, staticUrl) {
  wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    ...ticket,
    jsApiList: [
      "updateAppMessageShareData",
      "updateTimelineShareData",
      "onMenuShareAppMessage"
    ], // 必填，需要使用的JS接口列表
  });
  wx.checkJsApi({
    jsApiList: ["updateAppMessageShareData", "updateTimelineShareData", "onMenuShareAppMessage"], // 需要检测的JS接口列表，所有JS接口列表见附录2,
    success: () => {
      // 以键值对的形式返回，可用的api值true，不可用为false
      // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
      wx.ready(() => {
        let url = changeURLArg(location.href, 'exclusiveId', getStorage('liveuser').exclusiveId)
        //需在用户可能点击分享按钮前就先调用
        wx.updateAppMessageShareData({
          title: detail.name, // 分享标题
          link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: staticUrl || 'https://dstatic.wwjrxx.com/image/logo.jpg', // 分享图标
          desc: detail.description || '点击查看详情',
          success: () => {
            // 设置成功
            console.log("ok");
          },
          fail: () => {
            //需在用户可能点击分享按钮前就先调用
            wx.onMenuShareAppMessage({
              title: detail.name, // 分享标题
              link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: staticUrl || 'https://dstatic.wwjrxx.com/image/logo.jpg', // 分享图标
              desc: detail.description || '点击查看详情',
              success: () => {
                // 设置成功
                console.log("onMenuShareAppMessage ok");
              },
              fail: (error) => {
                console.log(error)
              },
            });
          },
        });
      });

      wx.ready(() => {
        wx.updateTimelineShareData({
          title: detail.name, // 分享标题
          link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: staticUrl || 'https://dstatic.wwjrxx.com/image/logo.jpg', // 分享图标
          success: () => {
            // 设置成功
            console.log("ok");
          },
        });
      });
    },
  });
}
/**
 * 判断手机是ios
 */
export function isIos() {
  var u = navigator.userAgent;
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  return isiOS
}

/**
 * 判断是否在微信环境
 */
export function isWeixin() {
  return navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1
}

/**
 * 生成uuid
 */
export function generateUUID() {
  var d = new Date().getTime();
  if (window.performance && typeof window.performance.now === "function") {
    d += performance.now(); //use high-precision timer if available
  }
  var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
    /[xy]/g,
    function (c) {
      var r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
    }
  );
  return uuid;
}

/**
 * 格式化表情的收发
 */
export function formatEmoji(messageItem) {
  const replaceArr = messageItem.data.match(/[0-9]{0,}>/g);
  let otherMessage = messageItem.data.replace(/<:\//g, '<img class="emoji-icon" src="https://dstatic.wwjrxx.com/emoji/');
  if (replaceArr) {
    for (let i = 0; i < replaceArr.length; i++) {
      let index = replaceArr[i].replace('>', '');
      otherMessage = otherMessage.replace(/\/emoji\/[0-9]{0,}>/, `/emoji/${index}.png">`);
    }
  }
  messageItem.data = otherMessage
  return messageItem
}

/**
 * 发送弹幕
 */
export function showDanmu(item, that) {
  let txt = null
  if (item.dataType === 6) { // 订单
    txt = `🌹${item.cloudUserName}刚刚购买了【${item.data.name}】🌹`;
  } else if (item.dataType === 8) { // 授课
    let shouke = item.data
    txt = shouke.dataType === 0 ? shouke.data : '管理员发送了图片，全屏暂不支持查看'
  } else if (item.dataType === 7) { // 回复
    txt = `@${item.aUserName}  ${item.data}`
  } else {
    // txt = item.data.replace(/<img.*\/>/gi, "").replace(/<img.*>/gi, "").replace(/<\/?strong[^>]*>/gi, "");
    txt = item.data.replace(/<\/?strong[^>]*>/gi, "");
  }
  let node = document.createElement('span')
  if(item.userType===1 && item.dataType!==6){
    // let adminNode = document.createElement('span')
    node.innerHTML = `<span class="danmutag">${item.dataType===8? '授课':'管理员'}</span>`
    // node.appendChild(adminNode)
  }
  let txtNode = document.createElement('span')
  txtNode.innerHTML =  isPc() ?  `<span style="color:#fff;text-shadow: 0 0 2px rgb(0 0 0 / 80%), 0 1px 0 rgb(0 0 0 / 80%), 0 0 2px rgb(0 0 0 / 80%), 0 0 1px rgb(0 0 0 / 80%);font-size:20px">${item.cloudUserName}: ${txt}</span>` : `<span style="color:#fff;text-shadow: rgba(0,0,0,.2) 1px 0px 0px, rgba(0,0,0,.2) 0px 1px 0px, rgba(0,0,0,.2) -1px 0px 0px, rgba(0,0,0,.2) 0px -1px 0px;font-size:20px">${item.cloudUserName}: ${txt}</span>`
  txtNode.className = 'danmu-txt'
  node.className = 'danmu-content'
  node.appendChild(txtNode)
  
  // if (dom.length > 0) {
    that.player && that.player.danmu &&
      that.player.danmu.sendComment({
        //发送弹幕
        duration: 15000,
        id: Math.random() * 10000,
        start: 0,
        color: true,
        // txt: item.dataType === 6 ? `🌹${item.cloudUserName}：` + txt + "🌹" : `${item.cloudUserName}：` + txt,
        // style: {
          // color: "#fff",
          // fontSize: "20px",
          // border: "solid 1px #ff9500",
          // borderRadius: "50px",
          // padding: "5px 8px",
          // textShadow: "#000 3px 3px 3px",
        // },
        el: node
      });
  // }
  that.player.danmu.play();
}

/**
 * div滚动到到底部
 */
export function scrollToBottom(idName, that) {
  that.$nextTick(() => {
    // setTimeout(() => {
      let container = that.$refs[`${idName}`]
      if(container){
        container.scrollTop = container.scrollHeight + 1
      }
    // }, 500)
  });
}

/**
 * div是否滚动到顶部
 */
export function isScrollTop(idName, that){
  let box = that.$refs[idName]
  let scrollTop = box.scrollTop;
  if (scrollTop > 0) {
    return false
  } else {
     return true
  }
}

/**
 * 判断是否滚动到了底部
 */
export function isScrollBottom(idName, that) {
  // 是否滚动到了底部
  let box = that.$refs[idName]
  var clientHeight = box.clientHeight
  var scrollTop = parseInt(box.scrollTop)
  var scrollHeight = box.scrollHeight
  if (scrollHeight > scrollTop && scrollTop + clientHeight + 1 >= scrollHeight) {
    return true
  } else {
    return false
  }
}

/**
 * 滚动方向判断
 */
var initTop = 0
export function getDirection(idName, that, dom) {
  // scroll滚动方向~~~~
  let box = dom? dom : that.$refs[idName]
  var scrollTop = dom? dom.getOffset() : box.scrollTop
  var scroll = scrollTop - initTop
  initTop = scrollTop
  let dir = ''
  if (scroll < 0) {
    dir = 'up'
  } else {
    dir = 'down'
  }
  return dir
}

/**
 * 特殊请求异常捕获
 */
export function catchError(error) {
  const { status } = error.response
  if (status === 401) {
    Toast.fail('登录过期')
    sessionStorage.clear()
    localStorage.clear()
   if(location.href.includes('serviceTermination')) {
    let url = delQueryString(location.href, 'code');
    location.href = location.origin + '/login?url='+ url
   }
  } else if (status === 403) {
    Toast.fail('暂无权限')
  } else if (status === 404) {
    Toast.fail('网络请求不存在')
  } else if (status === 500) {
    Toast.fail('服务器异常')
  } else if (status === 502) {
    Toast.fail('服务器未响应')
  } else {
    Toast.fail('网络开小差了～')
  }
}

// 删除地址栏的某个参数
export function delQueryString(url, paramKey) {
  let beforeUrl = url.substr(0, url.indexOf("?"));   //?之前主地址
  let afterUrl = url.substr(url.indexOf("?") + 1);   //？之后参数路径
  let nextUrl = "";

  let arr = new Array();
  if (afterUrl != "") {
    let urlParamArr = afterUrl.split("&"); //将参数按照&符分成数组
    for (let i = 0; i < urlParamArr.length; i++) {
      let paramArr = urlParamArr[i].split("="); //将参数键，值拆开
      //如果键雨要删除的不一致，则加入到参数中
      if (paramArr[0] !== paramKey) {
        arr.push(urlParamArr[i]);
      }
    }
  }
  if (arr.length > 0) {
    nextUrl = "?" + arr.join("&");
  }
  url = beforeUrl + nextUrl;
  return url;
}

/**
 * 设置cookie
 */
export function setCookie(c_name,value,expire) {
    var date=new Date()
    date.setSeconds(date.getSeconds()+expire)
    document.cookie=c_name+ "="+escape(value)+"; expires="+date.toGMTString()
    //console.log(document.cookie)
}
 /**
  * 获取cookie
  */
export function getCookie(c_name){
    if (document.cookie.length>0){
        let c_start=document.cookie.indexOf(c_name + "=")
        if (c_start!=-1){ 
            c_start=c_start + c_name.length+1 
            let c_end=document.cookie.indexOf(";",c_start)
            if (c_end==-1) c_end=document.cookie.length
                return unescape(document.cookie.substring(c_start,c_end))
        } 
    }
    return ""
}
 /**
  * 删除cookie
  */
export function delCookie(c_name){
    setCookie(c_name, "", -1)
}
/**
 * 数字金额转成大写
 * @param {*} money 
 * @returns 
 */
export function numberToChnPrice(money) {
  //汉字的数字
  var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');
  //基本单位
  var cnIntRadice = new Array('', '拾', '佰', '仟');
  //对应整数部分扩展单位
  var cnIntUnits = new Array('', '万', '亿', '兆');
  //对应小数部分单位
  var cnDecUnits = new Array('角', '分', '毫', '厘');
  //整数金额时后面跟的字符
  var cnInteger = '整';
  //整型完以后的单位
  var cnIntLast = '元';
  //最大处理的数字
  var maxNum = 999999999999999.9999;
  //金额整数部分
  var integerNum;
  //金额小数部分
  var decimalNum;
  //输出的中文金额字符串
  var chineseStr = '';
  //分离金额后用的数组，预定义
  var parts;
  if (money == '') { return ''; }
  money = parseFloat(money);
  if (money >= maxNum) {
    //超出最大处理数字
    return '';
  }
  if (money == 0) {
    chineseStr = cnNums[0] + cnIntLast + cnInteger;
    return chineseStr;
  }
  //转换为字符串
  money = money.toString();
  if (money.indexOf('.') == -1) {
    integerNum = money;
    decimalNum = '';
  } else {
    parts = money.split('.');
    integerNum = parts[0];
    decimalNum = parts[1].substr(0, 4);
  }
  //获取整型部分转换
  if (parseInt(integerNum, 10) > 0) {
    var zeroCount = 0;
    var IntLen = integerNum.length;
    for (var i = 0; i < IntLen; i++) {
      var n = integerNum.substr(i, 1);
      var p = IntLen - i - 1;
      var q = p / 4;
      var m = p % 4;
      if (n == '0') {
        zeroCount++;
      } else {
        if (zeroCount > 0) {
          chineseStr += cnNums[0];
        }
        //归零
        zeroCount = 0;
        chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
      }
      if (m == 0 && zeroCount < 4) {
        chineseStr += cnIntUnits[q];
      }
    }
    chineseStr += cnIntLast;
  }
  //小数部分
  if (decimalNum != '') {
    var decLen = decimalNum.length;
    for (var i = 0; i < decLen; i++) {
      var n = decimalNum.substr(i, 1);
      if (n != '0') {
        chineseStr += cnNums[Number(n)] + cnDecUnits[i];
      }
    }
  }
  if (chineseStr == '') {
    chineseStr += cnNums[0] + cnIntLast + cnInteger;
  } else if (decimalNum == '') {
    chineseStr += cnInteger;
  }
  return chineseStr;
}
 
export const dialByPhone = () => {
  if(window.location.search.includes('come')){
    const come = window.location.search.substring(1).split("&").find((item) => item.split("=")[0] === "come").split("=")[1];
    if(["gdapp","app-windows","app-mac"].includes(come)){
      let useAppWebView = null;
      if(window.location.search.includes('useAppWebView')){ 
        useAppWebView =  window.location.search.substring(1).split("&").find((item) => item.split("=")[0] === "useAppWebView").split("=")[1]; 
      }
      
      if(useAppWebView && useAppWebView === 'false'){
        const postData = { handleName: "dialByPhone" };
      if (["app-windows"].includes(come)) {
        window.chrome.webview.postMessage(JSON.stringify(postData));
        return;
      }
      if (["app-mac"].includes(come)) {
        window.webkit.messageHandlers.sendMessageToMac.postMessage(JSON.stringify(postData));
        return;
      }
      }
       window.flutter_inappwebview.callHandler("dialByPhone");
    }else{
      window.location.href = "tel:400-788-2598";
    }
  }else{
    window.location.href = "tel:400-788-2598";
  }
}


